module.exports = __webpack_public_path__ + "static/media/book-heart.6d11cb10.svg";